import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateIssuePresignedUrlInput,
  CreateIssuePresignedUrlResponse,
  MutationCreateIncidentIssueDocumentPresignedUploadUrlArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { CreateIncidentIssueDocumentPresignedUploadUrlDocument } from '@/api/queries';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateIssuePresignedUrlInput]?: CreateIssuePresignedUrlInput[key];
};
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateIssuePresignedUrlResponse>;
}

// Incident PresignedURL Service
export const { createIncidentIssueDocumentPresignedUrl, useCreateIncidentIssueDocumentPresignedUrl } = ((): {
  createIncidentIssueDocumentPresignedUrl: ServiceMethod;
  useCreateIncidentIssueDocumentPresignedUrl: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(CreateIncidentIssueDocumentPresignedUploadUrlDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateIssuePresignedUrlInput, options?: ConnectionOptions): Promise<CreateIssuePresignedUrlResponse> => {
        const args: MutationCreateIncidentIssueDocumentPresignedUploadUrlArgs = {
          input: payload,
        };
        const opts = { merge: options?.merge ? 'createIncidentIssueDocumentPresignedUploadUrl' : undefined };
        const res = await fn(args, opts);
        return getProperty('createIncidentIssueDocumentPresignedUploadUrl', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createIncidentIssueDocumentPresignedUrl: fetch,
    useCreateIncidentIssueDocumentPresignedUrl: useService,
  };
})();
